import { extendTheme } from '@chakra-ui/react';
import type { StyleFunctionProps } from '@chakra-ui/styled-system';

import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

import Button from '../components/button/styles';
import Checkbox from '../components/checkbox/styles';
import Heading from '../components/heading/styles';
import Input from '../components/input/styles';
import Modal from '../components/modal/styles';
import Select from '../components/select/styles';
import Stat from '../components/stat/styles';
import Switch from '../components/switch/styles';
import Tabs from '../components/tabs/styles';
import Text from '../components/text/styles';

const theme = extendTheme({
    config: {
        initialColorMode: 'system',
        useSystemColorMode: true,
    },
    fonts: {
        heading: "'Poppins', sans-serif",
        body: "'Poppins', sans-serif",
    },
    colors: {
        primary: '#C0E800',
        secondary: '#78B8F4',
        lime: '#C0E800',
        skyBlue: '#78B8F4',
        midnightBlue: '#24356A',
        darkNavy: '#08193E',
        navy: '#060D2F',
        border: '#E1E1E1',
        green: '#75C113',
        red: '#F35E5E',
        softGray: '#FBFBFB',
        alphaWhite01: 'rgba(255,255,255,0.1)',
        alphaWhite003: 'rgba(255,255,255,0.03)',
        alphaWhite005: 'rgba(255,255,255,0.05)',
        alphaWhite008: 'rgba(255, 255, 255, 0.08)',
        skyGradient:
            'linear-gradient(0deg, rgba(120, 184, 244, 0.15), rgba(120, 184, 244, 0.15)), #FFFFFF',
        skyGradientActive:
            'linear-gradient(0deg, rgba(120, 184, 244, 0.3), rgba(120, 184, 244, 0.3)), #FFFFFF',
        skyGradientActiveDark:
            'linear-gradient(0deg, rgba(120, 184, 244, 0.1), rgba(120, 184, 244, 0.1)), rgba(255, 255, 255, 0.05)',
        skySoft: 'rgba(120, 184, 244, 0.05)',
    },
    styles: {
        global: (props: StyleFunctionProps) => ({
            body: {
                bg: props.colorMode === 'light' ? 'softGray' : 'navy',
                color: props.colorMode === 'light' ? 'navy' : 'white',
            },
        }),
    },
    components: {
        Button,
        Heading,
        Text,
        Checkbox,
        Switch,
        Input,
        Select,
        Tabs,
        Stat,
        Modal,
    },
});

export default theme;
